var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetUnitSmall',{attrs:{"title":_vm.unitShortIdentifier,"subtitle":_vm.subtitleText}})
}
var staticRenderFns = []

export { render, staticRenderFns }